import React from 'react';
import PropTypes from 'prop-types';
import MarketShare from 'components/partials/charts/ShareChart';
import {
  transformPieChartData,
  generateStationGroup,
  removeDuplicated
} from '../ProductionDashboardHelpers';

export default function DeliveryTab({ productionItems }) {
  return (
    <div>
      <h3>Delivery</h3>
      <div className="charts-grid">
        {productionItems && productionItems.length > 0
          ? productionItems.map((station, ind) => (
              <MarketShare
                key={ind}
                data={transformPieChartData(station.value, 'route', station.key)}
                radius={['95%', '83%']}
                title={generateStationGroup(station.key)}
                summary={
                  station.key === 'sashAssembly'
                    ? removeDuplicated(station.value)?.length?.toString()
                    : station.value.length?.toString()
                }
              />
            ))
          : (
              <div className="w-100 p-4 text-center border rounded">
                No delivery data available for this date.
              </div>
            )}
      </div>
    </div>
  );
}

DeliveryTab.propTypes = {
  productionItems: PropTypes.array.isRequired
};
